module.exports = __webpack_public_path__ + "img/6.83f1bb0b.svg";